import { useEffect, useState } from 'react';
import { getFirebaseAuth } from './firebase';

// The Outclose role model lives in Firebase custom claims (`role`). The main
// app read it via its /profile endpoint; here we read it straight off the ID
// token, which carries the same claim.
export type Role = 'admin' | 'moderator' | 'analytics' | 'creative' | 'tester' | null;

export function useRole(): {
  role: Role;
  loading: boolean;
  isAdmin: boolean;
  hasAnalyticsAccess: boolean;
  hasCreativeAccess: boolean;
} {
  const [role, setRole] = useState<Role>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const user = getFirebaseAuth().currentUser;
    if (!user) {
      setLoading(false);
      return;
    }
    user
      .getIdTokenResult()
      .then((r) => {
        if (!cancelled) setRole((r.claims.role as Role) ?? null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    role,
    loading,
    isAdmin: role === 'admin',
    hasAnalyticsAccess: role === 'admin' || role === 'analytics',
    hasCreativeAccess: role === 'admin' || role === 'creative',
  };
}
